module.exports = __webpack_public_path__ + "static/media/YF104_1.e4a9a627.jpg";